import { render, staticRenderFns } from "./ForeignLanguageInput.vue?vue&type=template&id=0110396f&scoped=true"
import script from "./ForeignLanguageInput.vue?vue&type=script&lang=js"
export * from "./ForeignLanguageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110396f",
  null
  
)

export default component.exports